import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields } from "remult";
import { LandingPageConfigEntityConfig } from "./config";
import { LandingPageConfigFilters } from "./filters";
import { LandingPageConfigMethods } from "./methods";

/** Where this landing page is shown: standalone (/landing) or as gate above feed / user-request / auth */
export const LANDING_PAGE_TYPE = ["STANDALONE", "FEED", "USER_REQUEST", "AUTH"] as const;
export type LandingPageType = (typeof LANDING_PAGE_TYPE)[number];

@HyperEntity<LandingPageConfig>("landing-page", LandingPageConfigEntityConfig)
export class LandingPageConfig extends extender(
  LandingPageConfigFilters,
  LandingPageConfigMethods,
) {
  @Fields.id()
  id = "";

  @Fields.literal(() => LANDING_PAGE_TYPE, { dbName: "landing_type" })
  landingType: LandingPageType = "STANDALONE";

  @Fields.string()
  title = "";

  @Fields.string()
  subtitle = "";

  @Fields.string()
  description = "";

  @Fields.string({ dbName: "button1_text" })
  button1Text = "";

  @Fields.string({ dbName: "button1_link" })
  button1Link = "";

  @Fields.string({ dbName: "button2_text" })
  button2Text = "";

  @Fields.string({ dbName: "button2_link" })
  button2Link = "";

  @Fields.createdAt({ dbName: "created_at" })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();
}
